import {connect} from 'react-redux';
import {Dispatch} from 'redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {LensModel} from '../../../../models/api/lensModel';
import {WorkspaceDropReorderTeammateHandler} from '../../../../store/data/workspace/reorder/types';
import {LensesWorkspaceItemContainerBase} from './lensesWorkspaceItemContainerBase';

/*
 * Props.
 */

interface LensWorkspaceItemContainerProps {
  lens: LensModel;
}

/*
 * Selectors.
 */

// TODO-LENS: remove if not adding anything here.

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensWorkspaceItemContainerProps>()(() => ({
  // TODO-LENS: remove if not adding anything here.
}));

function mapDispatchToProps(dispatch: Dispatch, _props: LensWorkspaceItemContainerProps) {
  return {
    // TODO-LENS: remove if not adding anything here.
  };
}

/** For use in displaying a lens in the lenses workspace. Not to be used when editing the workspace. */
export const LensesWorkspaceItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onDropReorderLens: WorkspaceDropReorderTeammateHandler = (dropArgs) => {
      // TODO-LENS: determine reordering for Fronteer release.
      // trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_REORDER, {
      //   section: WorkspaceDisplaySectionTrackingTypesEnum.LENS,
      // });
      // dispatchProps.reorderTeammateInTeammatesWorkspace(dropArgs);
    };

    return {
      ...ownProps,
      canBeHidden: true,
      shouldHideMoreMenu: false,
      isEditingWorkspace: false,
      onDropReorderLens,
    };
  },
)(LensesWorkspaceItemContainerBase);
